/**
 * Masked display (ADR-012 §4). The last four digits of the SSN are the only digits that ever
 * render without a reveal, and a date of birth renders no digits at all.
 *
 * Both functions take no more than they may show: `maskSsn` accepts the last four only, so a
 * caller holding the full number cannot hand it over and trust the mask to trim it.
 */
export const SENSITIVE_MASK_CHAR = '•';
export const SSN_LAST4_PATTERN = /^\d{4}$/;
export function maskSsn(last4) {
    if (!SSN_LAST4_PATTERN.test(last4))
        throw new Error('maskSsn takes the last four digits only');
    return `${SENSITIVE_MASK_CHAR.repeat(3)}-${SENSITIVE_MASK_CHAR.repeat(2)}-${last4}`;
}
export function maskDateOfBirth() {
    return `${SENSITIVE_MASK_CHAR.repeat(2)}/${SENSITIVE_MASK_CHAR.repeat(2)}/${SENSITIVE_MASK_CHAR.repeat(4)}`;
}
//# sourceMappingURL=masking.js.map